// test795
(795 && 0);
